import type { ConnectionPoint, Point, Size } from '../state/types';

export const buildEdgeMidpoints = (
  id: string,
  position: Point,
  size: Size
): ConnectionPoint[] => {
  const { x, y } = position;
  const { width, height } = size;

  return [
    {
      id: `${id}-top`,
      position: { x: x + width / 2, y },
      direction: 'top',
    },
    {
      id: `${id}-right`,
      position: { x: x + width, y: y + height / 2 },
      direction: 'right',
    },
    {
      id: `${id}-bottom`,
      position: { x: x + width / 2, y: y + height },
      direction: 'bottom',
    },
    {
      id: `${id}-left`,
      position: { x, y: y + height / 2 },
      direction: 'left',
    },
  ];
};
